import { graphql } from "@opensea/graphql"

export const profileItemPaginatorFragment = graphql(`
  fragment ProfileItemPaginator on Item {
    id
    createdAt
    rarity {
      rank
    }
    collection {
      floorPrice {
        pricePerItem {
          usd
        }
      }
      topOffer {
        pricePerItem {
          usd
        }
      }
    }
    bestListing {
      startTime
      pricePerItem {
        usd
      }
    }
    bestOffer {
      pricePerItem {
        usd
      }
    }
    lastSaleAt
    lastSale {
      usd
    }
    lastTransferAt
    ownership(address: $address) {
      id
    }
    lowestListingForOwner(address: $address) {
      pricePerItem {
        usd
      }
    }
  }
`)
